module.exports = __webpack_public_path__ + "img/brandImg7.798be249.jpg";